module.exports = __webpack_public_path__ + "static/img/fb.015b585.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/community/fb.png
// module id = 975i
// module chunks = 7